import {
    Box,
    AppBar,
    Toolbar,
    IconButton,
    useMediaQuery,
    useTheme,
    Avatar,
    Menu,
    MenuItem,
    Stack,
    Button,
    Popper,
    Typography,
} from '@mui/material'
import pxToRem from '../../../helpers/pxToRem'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { TabNames, DashboardTabNames } from '../../../routers/type'
import styles from '../DashboardHeader.module.scss'
import HomeIcon from '@mui/icons-material/Home'
import sparkLogo from '../../../assets/images/share/sparkIcon.png'
import { RootState } from '../../../redux/store'

import MenuIcon from '@mui/icons-material/Menu'
import useSignOutUser from '../../../hooks/useSignOutUser'
import { tabNames } from '../../../routers/helpers'
import { selectUserAccountTypeCheck } from '../../../redux/userSlice'

const MENU_ITEMS = [
    {
        label: 'Home',
        name: '',
        link: `/${TabNames.DASHBOARD}`,
        icon: <HomeIcon />,
    },
    {
        label: 'My Account',
        name: 'my-account',
        link: `/${TabNames.DASHBOARD}/${DashboardTabNames.MY_ACCOUNT}`,
    },
    // {
    //     label: 'Help Desk',
    //     name: 'help',
    //     link: `/${TabNames.DASHBOARD}/${DashboardTabNames.HELP_DESK}`,
    // },
    // {
    //     label: 'Settings',
    //     name: 'settings',
    //     link: `/${TabNames.DASHBOARD}/${DashboardTabNames.SETTINGS}`,
    // },
]

const FallbackHeader = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const isUserData = useSelector((state: RootState) => !!state.user.user.data)
    const profilePictureURL = useSelector(
        (state: RootState) => state.user.user.data?.profilePictureURL
    )

    const path = location.pathname.substring(
        location.pathname.lastIndexOf('/') + 1
    )
    const [selectedTab, setSelectedTab] = useState(
        path === ''
            ? 0
            : MENU_ITEMS.findIndex(
                  (el) =>
                      el.link.substring(el.link.lastIndexOf('/') + 1) === path
              )
    )
    const onTabChange = (e: React.SyntheticEvent, newValue: number) => {
        if (newValue >= 0 && newValue < MENU_ITEMS.length) {
            navigate(MENU_ITEMS[newValue].link)
            setSelectedTab(newValue)
        }
    }

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [anchorEl, setAnchorEl] = useState<null | Element>(null)
    const handleMenu = (event: React.MouseEvent<Element>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const [signOutUser] = useSignOutUser()
    const logout = () => signOutUser(() => navigate('/'))

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <AppBar
                position="static"
                sx={{
                    padding: `${pxToRem(0)} ${pxToRem(20)}`,
                    backgroundColor: 'inherit',
                    boxShadow: 'none',
                }}
            >
                <Toolbar>
                    <img
                        className={styles.icon}
                        src={sparkLogo}
                        alt="Spark Icon (Text only)"
                        onClick={() => navigate(`/`)}
                    />
                    <Stack
                        direction="row"
                        sx={{ flexGrow: 1, gap: pxToRem(40) }}
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                    >
                        {isMobile ? <MobileHeader logout={logout} /> : null}
                        {!isMobile && isUserData ? (
                            <div>
                                <Button
                                    variant="text"
                                    color="shades100"
                                    onClick={() =>
                                        navigate(`/${tabNames.app.index}`)
                                    }
                                >
                                    Home
                                </Button>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                    sx={{ marginLeft: pxToRem(40) }}
                                >
                                    <Avatar
                                        src={profilePictureURL || sparkLogo}
                                        alt="User Photo"
                                    />
                                </IconButton>

                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            className: styles.dotButtonMenu,
                                        },
                                        list: {
                                            className: styles.menuListcontainer,
                                        },
                                    }}
                                >
                                    <MenuItem
                                        className={styles.hoverMenuItem}
                                        onClick={logout}
                                    >
                                        Logout
                                    </MenuItem>
                                </Menu>
                            </div>
                        ) : null}
                    </Stack>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

const MobileHeader = ({ logout }: { logout: () => void }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget)
    }

    const open = Boolean(anchorEl)

    const accountType = useSelector(selectUserAccountTypeCheck)
    const navigate = useNavigate()

    if (!accountType) return null

    const handleNav = (d: 'help' | 'logout') => {
        switch (d) {
            case 'help': {
                navigate(`/${TabNames.HELP_DESK}`)
                break
            }
            case 'logout': {
                logout()
                break
            }
        }

        setAnchorEl(null)
    }

    return (
        <>
            <IconButton onClick={handleClick}>
                <MenuIcon />
            </IconButton>
            <Popper
                open={open}
                anchorEl={anchorEl}
                sx={{
                    zIndex: 5,
                    width: '100vw',
                    height: 'calc(100dvh - 56px)',
                    background: '#fff',
                    px: 3,
                }}
            >
                <Stack
                    sx={{
                        '> .MuiBox-root': {
                            py: 3,
                            borderBottom: `1px solid ${styles.neutrals100}`,
                            cursor: 'pointer',
                            '&:last-of-type': {
                                borderBottom: 'none',
                                cursor: 'default',
                            },
                        },
                    }}
                >
                    <Box onClick={() => handleNav('help')}>Help Desk</Box>
                    <Box onClick={() => handleNav('logout')}>Log Out</Box>
                    <Box>
                        <Typography>Download our app</Typography>
                        <Stack
                            mt={3}
                            gap={1.5}
                            sx={{
                                width: '174px',
                                maxWidth: '100%',
                                '> .MuiStack-root': {
                                    p: 1.5,
                                    gap: 1.5,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    borderRadius: '80px',
                                    background: styles.primaryYellow500,
                                    cursor: 'pointer',
                                    '> .MuiTypography-root': {
                                        color: styles.shades0,
                                    },
                                },
                            }}
                        >
                            <Stack
                                role="button"
                                onClick={() =>
                                    window.open(
                                        process.env.REACT_APP_APPSTORE,
                                        '_blank'
                                    )
                                }
                            >
                                {/* prettier-ignore */}
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.5871 10.636C12.5661 8.10926 14.5032 6.88001 14.5918 6.82278C13.4947 5.09572 11.7943 4.85975 11.1967 4.84094C9.76854 4.67866 8.38321 5.76366 7.65569 5.76366C6.91365 5.76366 5.79334 4.85662 4.58589 4.88327C3.03211 4.90914 1.57853 5.88047 0.781315 7.3888C-0.863947 10.4643 0.363102 14.9838 1.93939 17.4697C2.72789 18.6872 3.64927 20.0466 4.85526 19.9988C6.03512 19.9462 6.47584 19.1866 7.89965 19.1866C9.31039 19.1866 9.72425 19.9988 10.9542 19.9682C12.2205 19.9462 13.0177 18.7452 13.7786 17.5168C14.6898 16.1213 15.0557 14.747 15.0703 14.6765C15.0405 14.6655 12.6111 13.6644 12.5871 10.636Z" fill="white"/> <path d="M10.2637 3.2056C10.8983 2.34874 11.3325 1.18299 11.212 0C10.2935 0.0439016 9.14485 0.685963 8.4834 1.52401C7.8982 2.2625 7.37543 3.47293 7.51048 4.61124C8.54222 4.69434 9.60154 4.04914 10.2637 3.2056Z" fill="white"/> </svg>
                                <Typography>App Store</Typography>
                            </Stack>
                            <Stack
                                role="button"
                                onClick={() =>
                                    window.open(
                                        process.env
                                            .REACT_APP_GOOGLEPLAYSTORE,
                                        '_blank'
                                    )
                                }
                            >
                                {/* prettier-ignore */}
                                <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.333511 0.308759C0.122257 0.547864 0 0.920128 0 1.40222V18.5983C0 19.0804 0.122257 19.4527 0.333511 19.6918L0.385651 19.7443L9.29788 10.112V9.8846L0.385651 0.252386L0.333511 0.308759Z" fill="white"/> <path d="M12.2653 13.3243L9.29785 10.112V9.88454L12.2689 6.67218L12.3354 6.71398L15.8539 8.87855C16.8581 9.49284 16.8581 10.5037 15.8539 11.1219L12.3354 13.2825L12.2653 13.3243Z" fill="white"/> <path d="M12.3354 13.2827L9.29787 9.99838L0.333496 19.6918C0.667008 20.0709 1.21087 20.1166 1.82936 19.7375L12.3354 13.2827Z" fill="white"/> <path d="M12.3354 6.71401L1.82936 0.259159C1.21087 -0.116021 0.667008 -0.07034 0.333496 0.308728L9.29787 9.99829L12.3354 6.71401Z" fill="white"/> </svg>
                                <Typography>Playstore</Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Popper>
        </>
    )
}

export default FallbackHeader
